import Vue from "vue";
import {API_HOST} from "../settings/server";
import $store from "../store";
import axios from "axios";

class MailCreateService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    createFormPdfFile({receiver, address, area, region, document64}) {
        return Vue.axios.post(`${API_HOST}/api/PdfMail`, {
            Receiver: receiver,
            Address: address,
            Area: area.id,
            Region: region.id,
            Document64: document64
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }
}

export default new MailCreateService()